import { useId, useState } from 'react'
import { Props_SnippetTabSwitcher } from './TabSwitcher.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetTabSwitcher = (props: Props_SnippetTabSwitcher) => {
    const { snippet, heading, repeatable_tab } = props

    const [activeTab, setActiveTab] = useState(0)

    const snippetID = useId()
    const classBackground: string = snippet.background.value ? `snippet-tab-switcher--bg-${snippet.background.value}` : ''
    const classHeadingVisibility: string = !heading.visibility.value ? 'snippet-tab-switcher__heading--hidden' : ''

    return (
        <section className={`snippet-tab-switcher ${classBackground}`}>
            <div className="snippet-tab-switcher__container">
                <h2 id={`snippet-tab-switcher-${snippetID}`} className={`snippet-tab-switcher__heading ${classHeadingVisibility}`}>
                    {heading.content.value}
                </h2>

                <div
                    role="tablist"
                    aria-labelledby={`snippet-tab-switcher-${snippetID}`}
                    className="snippet-tab-switcher__container-tabs"
                >
                    {repeatable_tab.map((tab, index) => (
                        <button
                            key={`snippet-tab-switcher-${snippetID}-btn-${index}`}
                            role="tab"
                            aria-selected={activeTab === index}
                            aria-controls={`snippet-tab-switcher-${snippetID}-${index}`}
                            className="snippet-tab-switcher__tabs-button"
                            onClick={() => setActiveTab(index)}
                        >
                            {tab.label?.value}
                        </button>
                    ))}
                </div>

                <div className="snippet-tab-switcher__container-content">
                    {repeatable_tab.map((tab, index) => (
                        <article
                            key={`snippet-tab-switcher-${snippetID}-${index}`}
                            id={`snippet-tab-switcher-${snippetID}-${index}`}
                            role="tabpanel"
                            aria-hidden={activeTab !== index}
                            className="snippet-tab-switcher__tab"
                        >
                            <div className="snippet-tab-switcher__tab-body">
                                <h3 className="snippet-tab-switcher__tab-heading">{tab.heading?.value}</h3>
                                {tab.content?.value && (
                                    <div className="snippet-tab-switcher__tab-content">
                                        {CompileMarkdown(tab.content.value)}
                                    </div>
                                )}
                                <SnippetLink
                                    url={tab.linkHref?.value}
                                    className="snippet-tab-switcher__tab-link"
                                    linkStyles={tab.linkStyle?.value}
                                    openInNewTab={tab.linkTarget?.value}
                                    aria-label={tab.linkAriaLabel?.value || tab.linkText?.value}
                                >
                                    {tab.linkText?.value}
                                </SnippetLink>
                            </div>
                            {tab.image?.value && (
                                <div className="snippet-tab-switcher__tab-image-wrapper">
                                    <img
                                        className="snippet-tab-switcher__tab-image"
                                        src={tab.image.value}
                                        alt={tab.alt?.value ? tab.alt.value : ''}
                                        loading="lazy"
                                    />
                                    <img
                                        className="snippet-tab-switcher__tab-bg-image"
                                        src={`/Blob/images/snippets/tab-switcher/bg-${snippet.background.value}.webp`}
                                        alt=""
                                        aria-hidden="true"
                                        loading="lazy"
                                    />
                                </div>
                            )}
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetTabSwitcher
